import React, { useState, useEffect } from "react";

import { Text, InputText, Button, Spinner } from "triider-components";
import { validateUserFields } from "triider-components/src/lib/utils/userValidations";
import { maskCPF, maskPhone } from "triider-components/src/lib/utils/masks";

import { getUserByEmail, getUserByCheckoutToken } from "services/api/users";

import { getCheckoutLink } from "config/checkout";

import { uiHelpers } from "config/shared";

import * as s from "./styles";

export default function CheckoutLink({
  fields,
  setFields,
  validations,
  setValidations,
  checkout_token
}) {
  const [isLoading, setIsLoading] = useState(false);
  const { dispatchError, copyCheckoutTokenToClipboard } = uiHelpers();
  const [buttonValidationLoading, setButtonValidationLoading] = useState(false);

  function sendWhatsApp() {
    window.open(
      `https://api.whatsapp.com/send?phone=+55 ${
        fields.phone
      }&text=${getCheckoutLink(checkout_token)}`
    );
  }

  function setField({ target: { name, value } }) {
    setFields({ ...fields, [name]: value });
  }

  function setFieldValidation(key, value) {
    setValidations({ ...validations, [key]: value });
  }

  function setUserFields(user) {
    const { id, name, cpf, phone } = user || {};
    setFields({ ...fields, id, name, cpf, phone, validatedEmail: true });
  }

  async function checkIfUserExists() {
    const message = validateUserFields("email", fields.email);
    if (message) {
      setFieldValidation("email", message);
      return;
    }

    setFieldValidation("email", null);
    setButtonValidationLoading(true);

    try {
      const { user } = await getUserByEmail(fields.email);
      setUserFields(user);
    } catch (error) {
      dispatchError(error);
    }
    setButtonValidationLoading(false);
  }

  async function setUp() {
    if (checkout_token) {
      setIsLoading(true);

      try {
        const { user } = await getUserByCheckoutToken(checkout_token);
        setUserFields(user);
      } catch (error) {
        console.log("error :>> ", error);
      }
      setIsLoading(false);
    }
  }

  useEffect(() => {
    setUp();
  }, []);

  const inputProps = {
    height: "45px",
    borderRadius: "4px",
    borderColor: "greyMedium",
    maxWidth: "none"
  };

  function getContent() {
    const buttonProps = {
      background: "white",
      borderRadius: "4px",
      border: "greyMedium",
      noUpperCase: true,
      color: "greyMedium",
      height: "45",
      maxWidth: "160px",
      width: "160px",
      fontSize: "12",
      weight: "normal"
    };

    if (isLoading) {
      return (
        <s.LoadingContainer>
          <Spinner size="larger" />
        </s.LoadingContainer>
      );
    }

    if (checkout_token) {
      return (
        <>
          <Text color="greyMedium" size="14">
            Envie o link de cobrança ao proprietário para que o mesmo possa
            cadastrar o cartão de crédito.
          </Text>
          {fields.phone && (
            <s.Line>
              <InputText
                {...inputProps}
                name="phone"
                mask={maskPhone}
                value={fields.phone}
                width="100%"
                readonly="readonly"
              />
              <Button {...buttonProps} onClick={sendWhatsApp}>
                Enviar por Whats
              </Button>
            </s.Line>
          )}
          {/* <s.Line>
            <InputText
              {...inputProps}
              type="email"
              name="email"
              value={fields.email}
              width="100%"
              readonly="readonly"
            />
            <Button {...buttonProps} onClick={() => {}}>
              Enviar por e-mail
            </Button>
          </s.Line> */}
          <s.Line>
            <InputText
              {...inputProps}
              name="checkout_token"
              value={getCheckoutLink(checkout_token)}
              width="100%"
              readonly="readonly"
            />
            <Button
              {...buttonProps}
              onClick={() => copyCheckoutTokenToClipboard(checkout_token)}
            >
              Copiar link
            </Button>
          </s.Line>
        </>
      );
    }

    return (
      <>
        <s.Line>
          <InputText
            {...inputProps}
            error={validations.email}
            inputPlaceholder="Digite o e-mail do proprietário"
            type="email"
            name="email"
            onChange={setField}
            value={fields.email}
            width="100%"
          />
          <Button
            background="white"
            borderRadius="4px"
            border="greyMedium"
            noUpperCase
            color="primary"
            height="45"
            maxWidth="110px"
            width="110px"
            isLoading={buttonValidationLoading}
            onClick={checkIfUserExists}
          >
            Validar
          </Button>
        </s.Line>
        {fields.validatedEmail && (
          <>
            <InputText
              {...inputProps}
              error={validations.name}
              inputPlaceholder="Nome"
              type="text"
              name="name"
              onChange={setField}
              value={fields.name}
              width="100%"
            />
            <s.Line>
              <InputText
                {...inputProps}
                error={validations.cpf}
                inputPlaceholder="CPF"
                type="text"
                name="cpf"
                mask={maskCPF}
                onChange={setField}
                value={fields.cpf}
                width="100%"
                minWidth="none"
              />
              <InputText
                {...inputProps}
                error={validations.phone}
                inputPlaceholder="Telefone"
                type="text"
                name="phone"
                mask={maskPhone}
                onChange={setField}
                value={fields.phone}
                width="100%"
                minWidth="none"
              />
            </s.Line>
            <Text size="12">{`Cadastro${
              fields.id ? " " : " não "
            }localizado`}</Text>
          </>
        )}
      </>
    );
  }

  return <s.Container>{getContent()}</s.Container>;
}
